import i18n from "@/i18n";
import PageForm from "@/assets/ts/interfaces/form/pageForm";
import { Types } from "@/assets/ts/enums/form/types";
import { handle_age, handle_onboarding } from "@/assets/ts/onboarding/callbacks/handle_onboarding";

const questions:PageForm =
  {
    title: i18n.global.t('ca_legislation.onboarding.sidebar_title'),
    image: 'img/lamp-sidebar.png',
    form: [
      {
        title: i18n.global.t("ca_legislation.onboarding.questions.title_questions"),
        fields: [
            {
            key: "name",
            title: i18n.global.t("ca_legislation.onboarding.questions.name_title"),
            subtitle: i18n.global.t("ca_legislation.onboarding.questions.name_text"),
            type: Types.STRING,
            gtag: "name",
            rules: 'required|vopayNames'
          },
          {
            key: "surname",
            title: i18n.global.t("ca_legislation.onboarding.questions.surname_title"),
            subtitle: i18n.global.t("ca_legislation.onboarding.questions.surname_text"),
            type: Types.STRING,
            gtag: "surname",
            rules: 'required|vopayNames'
          },
          {
            key: "address",
            title: i18n.global.t("ca_legislation.onboarding.questions.address_title"),
            subtitle: i18n.global.t("ca_legislation.onboarding.questions.address_text"),
            autocomplete: "address-line1",
            gtag: "address_input",
            type: Types.STRING,
            rules: 'required|vopayAddress'
          },          
          {
            key: "city",
            title: i18n.global.t("ca_legislation.onboarding.questions.city_title"),
            subtitle: i18n.global.t("ca_legislation.onboarding.questions.city_text"),
            type: Types.STRING,
            gtag: "city",
            rules: 'required|vopayCity'
          },
          {
            key: "region",
            title: i18n.global.t("ca_legislation.onboarding.questions.region_title"),
            subtitle: i18n.global.t("ca_legislation.onboarding.questions.region_text"),
            options: i18n.global.tm("ca_legislation.onboarding.questions.region_options"),
            type: Types.RADIO,
            gtag: "region",
            rules: 'required'
          },
          {
            key: "post_code",
            title: i18n.global.t("ca_legislation.onboarding.questions.post_code_title"),
            subtitle: i18n.global.t("ca_legislation.onboarding.questions.post_code_text"),
            type: Types.STRING,
            gtag: "post_code",
            rules: 'required|exactLength:6'
          },
          {
            key: "phone",
            title: i18n.global.t("ca_legislation.onboarding.questions.phone_title"),
            subtitle: i18n.global.t("ca_legislation.onboarding.questions.phone_text"),
            type: Types.NUMBER,
            gtag: "phone",
            rules: 'required|exactLength:10'
          },
          {
            key: "date_of_birth",
            title: i18n.global.t("ca_legislation.onboarding.questions.date_of_birth_title"),
            subtitle: i18n.global.t("ca_legislation.onboarding.questions.date_of_birth_18_text"),
            type: Types.DATE,
            limit: {min: 18, max: 100},
            condition: {
              key: 'region',
              value: 'MB'
            },
            gtag: "date_of_birth",
            rules: 'required'
          },
          {
            key: "date_of_birth",
            title: i18n.global.t("ca_legislation.onboarding.questions.date_of_birth_title"),
            subtitle: i18n.global.t("ca_legislation.onboarding.questions.date_of_birth_18_text"),
            type: Types.DATE,
            limit: {min: 18, max: 100},
            condition: {
              key: 'region',
              value: 'AB'
            },
            gtag: "date_of_birth",
            rules: 'required'
          },
          {
            key: "date_of_birth",
            title: i18n.global.t("ca_legislation.onboarding.questions.date_of_birth_title"),
            subtitle: i18n.global.t("ca_legislation.onboarding.questions.date_of_birth_18_text"),
            type: Types.DATE,
            limit: {min: 18, max: 100},
            condition: {
              key: 'region',
              value: 'ON'
            },
            rules: 'required'
          },          
          {
            key: "date_of_birth",
            title: i18n.global.t("ca_legislation.onboarding.questions.date_of_birth_title"),
            subtitle: i18n.global.t("ca_legislation.onboarding.questions.date_of_birth_19_text"),
            type: Types.DATE,
            limit: {min: 19, max: 100},
            condition: {
              key: 'region',
              value: 'NL'
            },
            gtag: "date_of_birth",
            rules: 'required'
          },
          {
            key: "date_of_birth",
            title: i18n.global.t("ca_legislation.onboarding.questions.date_of_birth_title"),
            subtitle: i18n.global.t("ca_legislation.onboarding.questions.date_of_birth_19_text"),
            type: Types.DATE,
            limit: {min: 19, max: 100},
            condition: {
              key: 'region',
              value: 'BC'
            },
            gtag: "date_of_birth",
            rules: 'required'
          },
          {
            key: "date_of_birth",
            title: i18n.global.t("ca_legislation.onboarding.questions.date_of_birth_title"),
            subtitle: i18n.global.t("ca_legislation.onboarding.questions.date_of_birth_19_text"),
            type: Types.DATE,
            limit: {min: 19, max: 100},
            condition: {
              key: 'region',
              value: 'NS'
            },
            gtag: "date_of_birth",
            rules: 'required'
          },
          {
            key: "date_of_birth",
            title: i18n.global.t("ca_legislation.onboarding.questions.date_of_birth_title"),
            subtitle: i18n.global.t("ca_legislation.onboarding.questions.date_of_birth_19_text"),
            type: Types.DATE,
            limit: {min: 19, max: 100},
            condition: {
              key: 'region',
              value: ''
            },
            gtag: "date_of_birth",
            rules: 'required'
          },
        ],
        next: true,
        otherCallback: handle_age,
        nextCallback: handle_onboarding,
        back: true
      }
    ]
}

export default questions
